// require("dotenv").config();
const uploadImage = async (image) => {

    const url = `https://api.cloudinary.com/v1_1/df2bnvuay/upload`;
    const formData = new FormData();
    formData.append("file", image);
    formData.append("upload_preset","mern_ecommerece"); 
    formData.append("resource_type", "image");
    


  
    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      return data.secure_url; // Return the URL of the uploaded image
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };
  
  export default uploadImage;
  